const STEPS_SELECTOR = '.js-steps';
const STEP_SELECTOR = '.js-step';
const LINE_SELECTOR = '.js-progressLine';
const LINE_FIRST_SELECTOR = '.js-progressLineFirst';
const OFFSET = 300; // px above step top to start
const FIRST_OFFSET = 400; // px above first step top to start
const FIRST_FILL_BEFORE = 100; // px before the trigger to fill the short first line
const PERSIST = false; // legacy flag (unused with new reversible logic)

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

function computeProgress(startY, endY, viewportTop, viewportBottom) {
    // start when OFFSET above startY enters viewport top
    const triggerStart = startY - OFFSET;
    const triggerEnd = endY - OFFSET;
    const progress = (viewportTop - triggerStart) / (triggerEnd - triggerStart);
    return clamp(progress, 0, 1);
}

function updateSteps(container) {
    const steps = Array.from(container.querySelectorAll(STEP_SELECTOR));
    const viewportTop = window.scrollY;
    const viewportBottom = viewportTop + window.innerHeight;

    // Handle first short line fill before first step activation (single block)
    const firstStep = steps[0];
    const firstLine = firstStep ? firstStep.querySelector(LINE_FIRST_SELECTOR) : null;
    let firstProgress = 0;
    if (firstStep && firstLine) {
        const firstRect = firstStep.getBoundingClientRect();
        const firstStartY = window.scrollY + firstRect.top;
        const triggerFirst = firstStartY - FIRST_OFFSET;
        // Fill from (triggerFirst - FIRST_FILL_BEFORE) → triggerFirst
        firstProgress = clamp((viewportTop - (triggerFirst - FIRST_FILL_BEFORE)) / FIRST_FILL_BEFORE, 0, 1);
        // If already activated, keep at 100%
        if (container._maxActiveIndex !== undefined && container._maxActiveIndex >= 0) {
            firstLine.style.setProperty('--progress', '100%');
        } else {
            firstLine.style.setProperty('--progress', `${firstProgress * 100}%`);
        }
    }

    // Determine activation per step based on trigger; reversible on scroll up
    const triggers = steps.map((stepEl, index) => {
        const rect = stepEl.getBoundingClientRect();
        const startY = window.scrollY + rect.top;
        return startY - (index === 0 ? FIRST_OFFSET : OFFSET);
    });
    const isActive = triggers.map(t => window.scrollY >= t);
    // Gate first activation until the short first line is filled
    if (!isActive[0] && firstProgress < 1) {
        isActive[0] = false;
    }
    const frontier = (() => {
        for (let i = isActive.length - 1; i >= 0; i--) if (isActive[i]) return i;
        return -1;
    })();

    // Update progress lines: past=100, future=0, frontier=live
    steps.forEach((stepEl, index) => {
        const line = stepEl.querySelector(LINE_SELECTOR);
        if (!line) return;
        if (index < frontier) {
            line.style.setProperty('--progress', '100%');
            return;
        }
        if (index > frontier) {
            line.style.setProperty('--progress', '0%');
            return;
        }
        if (index === frontier && frontier >= 0) {
            const rect = stepEl.getBoundingClientRect();
            const startY = window.scrollY + rect.top;
            const nextStep = steps[index + 1];
            const endY = nextStep
                ? window.scrollY + nextStep.getBoundingClientRect().top
                : window.scrollY + rect.bottom;
            const p = computeProgress(startY, endY, viewportTop, viewportBottom);
            line.style.setProperty('--progress', `${p * 100}%`);
            return;
        }
        // No active steps yet
        line.style.setProperty('--progress', '0%');
    });

    // Apply active classes
    steps.forEach((el, i) => {
        el.classList.toggle('-active', i <= frontier && frontier >= 0);
    });
}

function initSteps() {
    const containers = Array.from(document.querySelectorAll(STEPS_SELECTOR));
    if (containers.length === 0) return;

    const onScroll = () => containers.forEach(updateSteps);
    const onResize = () => containers.forEach(updateSteps);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    // Initial paint
    containers.forEach(updateSteps);
}

document.addEventListener('DOMContentLoaded', initSteps);